<style lang="scss" scoped>
.orden-asignacion-container {
  margin-top: 20px;
}

.info-box {
  background: linear-gradient(135deg, #e8f4f8 0%, #f0f8ff 100%);
  border-left: 4px solid #36c6d3;
  border-radius: 6px;
  padding: 0;
  margin-bottom: 25px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  
  .info-header {
    background: rgba(54, 198, 211, 0.1);
    padding: 12px 20px;
    border-bottom: 1px solid rgba(54, 198, 211, 0.2);
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    user-select: none;
    transition: background-color 0.2s ease;
    
    &:hover {
      background: rgba(54, 198, 211, 0.15);
    }
    
    i {
      color: #36c6d3;
      font-size: 18px;
    }
    
    strong {
      color: #2c3e50;
      font-size: 15px;
      flex: 1;
    }
    
    .chevron-icon {
      transition: transform 0.3s ease;
      font-size: 14px;
      
      &.rotated {
        transform: rotate(-90deg);
      }
    }
  }
  
  .info-content {
    padding: 15px 20px;
    color: #555;
    font-size: 14px;
    line-height: 1.6;
  }
}

.collapse-enter-active, .collapse-leave-active {
  transition: all 0.3s ease;
  max-height: 200px;
  overflow: hidden;
}

.collapse-enter, .collapse-leave-to {
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
}

.columnas-usuarios {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.columna-seccion {
  min-width: 0; // Prevent grid blowout
}

@media (max-width: 992px) {
  .columnas-usuarios {
    grid-template-columns: 1fr;
  }
}

.usuarios-container {
  min-height: 200px;
  padding: 15px;
  margin-bottom: 20px;
  border: 2px dashed #ddd;
  border-radius: 4px;
  background-color: #f9f9f9;

  &.activos {
    border-color: #36c6d3;
    background-color: #f0faff;
  }

  &.inactivos {
    border-color: #e7505a;
    background-color: #fff5f5;
    
    .usuario-card {
      opacity: 0.85;
    }
  }
}

.usuario-card {
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 15px;
  margin-bottom: 10px;
  cursor: grab;
  transition: all 0.3s ease;
  user-select: none;

  &:active {
    cursor: grabbing;
  }

  &:hover {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }

  .drag-handle {
    color: #999;
    font-size: 18px;
    margin-right: 5px;
    
    &:hover {
      color: #36c6d3;
    }
  }

  .usuario-nombre {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 5px;
    color: #333;
    display: flex;
    align-items: center;
    gap: 8px;
    
    .badge-prioridad {
      background-color: #36c6d3;
      color: white;
      font-size: 13px;
      font-weight: 700;
      padding: 4px 10px;
      border-radius: 50%;
      min-width: 32px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .usuario-email {
    color: #666;
    font-size: 13px;
    margin-bottom: 10px;
  }

  .usuario-total {
    display: flex;
    align-items: center;
    gap: 10px;

    label {
      margin: 0;
      font-weight: 600;
      color: #555;
      user-select: none;
    }

    input {
      width: 80px;
      padding: 5px 10px;
      border: 1px solid #ddd;
      border-radius: 3px;
      font-size: 14px;
      cursor: text;
      user-select: text;
    }
  }
}

.sortable-ghost {
  opacity: 0.4;
  background: #c8ebfb;
}

.sortable-chosen {
  opacity: 0.8;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.sortable-drag {
  opacity: 1;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.empty-state {
  text-align: center;
  color: #999;
  padding: 40px 20px;
  font-style: italic;
}

.btn-guardar {
  margin-top: 20px;
}
</style>

<template>
  <div class="orden-asignacion-container">
    <div v-if="!distribuidorSeleccionado" class="alert alert-info">
      <i class="fal fa-info-circle"></i>
      Por favor, seleccione un distribuidor para comenzar.
    </div>

    <div v-if="distribuidorSeleccionado && !cargando">

      <div class="info-box">
        <div class="info-header" @click="infoExpanded = !infoExpanded">
          <i class="fal fa-info-circle"></i>
          <strong>¿Qué es "Total de Leads"?</strong>
          <i class="fal fa-chevron-down chevron-icon" :class="{ 'rotated': !infoExpanded }"></i>
        </div>
        <transition name="collapse">
          <div v-show="infoExpanded" class="info-content">
            Es la cantidad máxima de leads que un usuario puede tener asignados al mismo tiempo en una ronda. 
            Una vez que todos los usuarios alcancen su total asignado, la ronda se reinicia y se asignan nuevos leads comenzando por el primero de la cola.
          </div>
        </transition>
      </div>

      <div class="columnas-usuarios">
        <div class="columna-seccion">
          <h4 class="text-success">
            <i class="fal fa-users"></i>
            Usuarios en la Cola de Asignación
          </h4>
          <p class="text-muted">
            Ordene los usuarios arrastrándolos. El orden define la prioridad de asignación de los leads desde el sistema.
          </p>
          <div ref="contenedorActivos" class="usuarios-container activos">
            <div v-if="activos.length === 0" class="empty-state">
              No hay usuarios en la cola. Arrastre usuarios desde la sección de abajo.
            </div>
            <div
              v-for="(usuario, index) in activos"
              :key="usuario.id"
              :data-id="usuario.id"
              class="usuario-card"
            >
              <div class="usuario-nombre">
                <span class="badge-prioridad">{{ index + 1 }}</span>
                {{ usuario.nombre }}
              </div>
              <div class="usuario-email">
                <i class="fal fa-envelope"></i>
                {{ usuario.email }}
              </div>
              <div class="usuario-total">
                <label>Total de Leads:</label>
                <input
                  type="number"
                  v-model.number="usuario.total"
                  min="0"
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="columna-seccion">
          <h4 class="text-danger">
            <i class="fal fa-user-slash"></i>
            Usuarios Excluidos de la Asignación
          </h4>
          <p class="text-muted">
            Los usuarios en esta sección no reciben leads del sitio web, ellos crean sus propios leads y se los asignan a sí mismos.
          </p>
          <div ref="contenedorInactivos" class="usuarios-container inactivos">
            <div v-if="inactivos.length === 0" class="empty-state">
              No hay usuarios excluidos.
            </div>
            <div
              v-for="(usuario, index) in inactivos"
              :key="usuario.id"
              :data-id="usuario.id"
              class="usuario-card"
            >
              <div class="usuario-nombre">
                {{ usuario.nombre }}
              </div>
              <div class="usuario-email">
                <i class="fal fa-envelope"></i>
                {{ usuario.email }}
              </div>
              <div class="usuario-total">
                <label>Total de Leads:</label>
                <input
                  type="number"
                  v-model.number="usuario.total"
                  min="0"
                  class="form-control"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <button
            class="btn btn-success btn-guardar"
            :disabled="guardando"
            @click="guardarCambios"
          >
            <i class="fal fa-save"></i>
            {{ guardando ? 'Guardando...' : 'Guardar Cambios' }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="cargando" class="text-center" style="padding: 40px">
      <i class="fal fa-spinner fa-spin fa-3x"></i>
      <p class="text-muted" style="margin-top: 10px">Cargando usuarios...</p>
    </div>
  </div>
</template>

<script>
import Sortable from 'sortablejs';

export default {
  name: 'OrdenAsignacion',
  
  data() {
    return {
      distribuidorSeleccionado: null,
      activos: [],
      inactivos: [],
      cargando: false,
      guardando: false,
      sortableActivos: null,
      sortableInactivos: null,
      infoExpanded: true,
    };
  },

  methods: {
    cargarUsuarios(distribuidorId) {
      this.distribuidorSeleccionado = distribuidorId;
      this.cargando = true;

      axios
        .get('/cotizacion/orden-asignacion/usuarios', {
          params: { distribuidor_id: distribuidorId },
        })
        .then(response => {
          this.activos = response.data.activos;
          this.inactivos = response.data.inactivos;
          this.cargando = false;

          // Esperar dos ticks para asegurar que Vue renderice completamente
          this.$nextTick(() => {
            this.$nextTick(() => {
              this.inicializarSortable();
            });
          });
        })
        .catch(error => {
          console.error('Error al cargar usuarios:', error);
          this.$toastr.error('Error al cargar los usuarios', 'Error');
          this.cargando = false;
        });
    },

    inicializarSortable() {
      if (this.sortableActivos) {
        this.sortableActivos.destroy();
      }
      if (this.sortableInactivos) {
        this.sortableInactivos.destroy();
      }

      // Verificar que los contenedores existen
      if (!this.$refs.contenedorActivos || !this.$refs.contenedorInactivos) {
        setTimeout(() => {
          this.inicializarSortable();
        }, 100);
        return;
      }

      const opcionesSortable = {
        animation: 150,
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen',
        dragClass: 'sortable-drag',
        group: 'usuarios',
        filter: 'input, textarea, select',
        preventOnFilter: false,
        draggable: '.usuario-card',
        onEnd: this.onSortEnd,
      };

      this.sortableActivos = Sortable.create(
        this.$refs.contenedorActivos,
        opcionesSortable
      );

      this.sortableInactivos = Sortable.create(
        this.$refs.contenedorInactivos,
        opcionesSortable
      );
    },

    onSortEnd(evt) {
      const itemId = parseInt(evt.item.dataset.id);
      const fromContainer = evt.from;
      const toContainer = evt.to;

      // Determinar si el elemento se movió entre contenedores
      const isActivos = toContainer === this.$refs.contenedorActivos;

      // Actualizar los arrays según el nuevo orden
      this.sincronizarArrays();
    },

    sincronizarArrays() {
      const activosElements = this.$refs.contenedorActivos.querySelectorAll(
        '.usuario-card'
      );
      const inactivosElements = this.$refs.contenedorInactivos.querySelectorAll(
        '.usuario-card'
      );

      const nuevosActivos = [];
      const nuevosInactivos = [];

      activosElements.forEach(el => {
        const id = parseInt(el.dataset.id);
        const usuario = this.activos.find(u => u.id === id) ||
                       this.inactivos.find(u => u.id === id);
        if (usuario) {
          nuevosActivos.push(usuario);
        }
      });

      inactivosElements.forEach(el => {
        const id = parseInt(el.dataset.id);
        const usuario = this.activos.find(u => u.id === id) ||
                       this.inactivos.find(u => u.id === id);
        if (usuario) {
          nuevosInactivos.push(usuario);
        }
      });

      this.activos = nuevosActivos;
      this.inactivos = nuevosInactivos;
    },

    guardarCambios() {
      this.guardando = true;

      const payload = {
        distribuidor_id: this.distribuidorSeleccionado,
        activos: this.activos.map((u, index) => ({
          id: u.id,
          total: u.total || 0,
        })),
        inactivos: this.inactivos.map(u => ({
          id: u.id,
          total: u.total || 0,
        })),
      };

      axios
        .post('/cotizacion/orden-asignacion/actualizar', payload)
        .then(response => {
          toastr.success('El orden de asignación se actualizó correctamente', 'Éxito');
          this.guardando = false;
        })
        .catch(error => {
          console.error('Error al guardar:', error);
          
          let errorMsg = 'Error al guardar los cambios';
          
          if (error.response && error.response.data) {
            if (error.response.data.errors) {
              const errores = Object.values(error.response.data.errors).flat();
              errorMsg = errores.join(', ');
            } else if (error.response.data.message) {
              errorMsg = error.response.data.message;
            }
          } else if (error.request) {
            errorMsg = 'No se recibió respuesta del servidor. Verifica tu conexión.';
          }
          
          toastr.error(errorMsg, 'Error');
          this.guardando = false;
        });
    },
  },

  mounted() {
    // Escuchar cambios en el select de distribuidor
    $('#cmbDistribuidor').on('change', e => {
      const distribuidorId = $(e.target).val();
      if (distribuidorId) {
        this.cargarUsuarios(distribuidorId);
      } else {
        this.distribuidorSeleccionado = null;
        this.activos = [];
        this.inactivos = [];
      }
    });
  },

  beforeDestroy() {
    if (this.sortableActivos) {
      this.sortableActivos.destroy();
    }
    if (this.sortableInactivos) {
      this.sortableInactivos.destroy();
    }
  },
};
</script>



// WEBPACK FOOTER //
// resources/vue/components/cotizacion/OrdenAsignacion.vue